var headers = {
  Authorization: "Bearer " + sessionStorage.getItem("jwt_token"),
};

var constants = {
  baseApiUrl: sessionStorage.getItem("customApiPath"),
  customUAEPassSignBaseApiUrl: sessionStorage.getItem(
    "customUAEPassSignApiPath"
  ),
  ctsApiUrl: sessionStorage.getItem("ctsApiUrl"),
  identityApiUrl: sessionStorage.getItem("authority"),
  viewerUrl: sessionStorage.getItem("viewerUrl"),
  client_version_Id: sessionStorage.getItem("client_version_Id"),
  signUsingUAEPassEnabled: JSON.parse(
    sessionStorage.getItem("sign_using_UAEPass")
  ),
  signUsingHashEnabled: JSON.parse(sessionStorage.getItem("sign_using_Hash")),
  signUsingDocusignEnabled: JSON.parse(
    sessionStorage.getItem("sign_using_Docusign")
  ),
  esealEnabled: JSON.parse(sessionStorage.getItem("eseal")),
  ltvEnabled: JSON.parse(sessionStorage.getItem("ltv")),
  enableSpecialTemplate: JSON.parse(
    sessionStorage.getItem("enableSpecialTemplate")
  ),
  isDesignPrimary: JSON.parse(sessionStorage.getItem("isDesignPrimary")),
  enableImpersonateSignatureInDelegation: sessionStorage.getItem(
    "enableImpersonateSignatureInDelegation"
  ),
  enableRecipientsMultiDocuments: sessionStorage.getItem(
    "enableRecipientsMultiDocuments"
  ),
  enableRecipientsMultiPages: sessionStorage.getItem(
    "enableRecipientsMultiPages"
  ),
  enableDirectDispatch: sessionStorage.getItem(
    "enableDirectDispatch"
  ),
  
  showReplyNeedReply: sessionStorage.getItem("showReplyNeedReply") === "true",
  showFilingClassificationPlanSections:
    sessionStorage.getItem("showFilingClassificationPlanSections") === "true",
  applicationTitle: sessionStorage.getItem("applicationTitle"),
  categories_has_configure_signature: sessionStorage.getItem(
    "categories_has_configure_signature"
  ),
  defaultApplicationId: sessionStorage.getItem("defaultApplicationId"),
  headers: headers,
  availableModules: sessionStorage.getItem("availableModules"),
  disclaimerMessage: sessionStorage.getItem("disclaimerMessage"),
  maxAttachmentSizeInByte: Window.maxAttachmentSizeInByte,
  maxAttachmentSizeInMb: Window.maxAttachmentSizeInMb,
  maxAttachmentSizeInByteAttachments: Window.maxAttachmentSizeInByteAttachments,
  maxAttachmentSizeInMbAttachment: Window.maxAttachmentSizeInMbAttachment,
  maxDispatchAttachmentSizeInByteAttachments: Window.maxDispatchAttachmentSizeInByteAttachments,
  maxDispatchAttachmentSizeInMbAttachment: Window.maxDispatchAttachmentSizeInMbAttachment,
  priorities: window.priorities,
  privacies: window.privacies,
  importancies: window.importancies,
  categories: window.categories,
  contactRoles: window.contactRoles,
  documentTypes: window.documentTypes,
  allowMultiStamp: JSON.parse(sessionStorage.getItem("allowMultiStamp")),
  ViewerActionUrl: sessionStorage.getItem("customApiPath") + "ViewerActions/",
  mandatoryDeliveryType: sessionStorage.getItem("mandatoryDeliveryType"),
  viewMultiDocumentOption:
    sessionStorage.getItem("viewMultiDocumentOption") === "true",
  viewer_enableShowStamps: true,
  isEsealEnabledTemplate: false,
  isUAEPassEnabledTemplate: true,
  templateMode: sessionStorage.getItem("templateMode"),
  showRejectButton: sessionStorage.getItem("showRejectButton"),
  showClassificationField: sessionStorage.getItem("showClassificationField"),
  contactRolesEnum: {
    Secretary: 1,
    Managers: 5,
  },
  fileExtensions: [
    { id: 1, name: "bmp" },
    { id: 2, name: "doc" },
    { id: 3, name: "docx" },
    { id: 4, name: "gif" },
    { id: 5, name: "jpg" },
    { id: 6, name: "pdf" },
    { id: 7, name: "png" },
    { id: 8, name: "ppt" },
    { id: 9, name: "pptx" },
    { id: 10, name: "svg" },
    { id: 11, name: "txt" },
    { id: 12, name: "xls" },
    { id: 13, name: "xlsx" },
    { id: 14, name: "bmp" },
    { id: 15, name: "tif" },
    { id: 16, name: "tiff" },
  ],
  languages: [
    { id: "EN", name: "English" },
    { id: "AR", name: "العربية" },
  ],
  applicationRoles: [],
  isApplicaitonRolesLoaded: false,

  delegations: [],
  isDelegationsLoaded: false,
  enableManageGridHeaders: true,
  canSignAndSend: false,
  canSign: false,
  canSendSecretTransfer: false,
  canOpenReports: false,
  isCompanyAdmin: false,
  isFullAdmin: false,
  isPermissionsLoaded: false,
  isDecreeEnabled: isDecreeEnabled,
  isCircularEnabled: isCircularEnabled,
  isContarctEnabled: isContarctEnabled,
  refreshSystemNotificationTimer: refreshSystemNotificationTimer,
  refreshPublicAnnouncementsTimer: refreshPublicAnnouncementsTimer,
  defaultDateValue: "dd/mm/yyyy",
  showDateWithTime: true,
  multiSelectDocument: window.selectMultiDocument,

  statuses: [
    { id: 1, name: "Draft", nameAr: "مسودة", key: "Draft", classColor: "" },
    {
      id: 2,
      name: "In progress",
      nameAr: "قيد التنفيذ",
      key: "InProgress",
      classColor: "info",
    },
    {
      id: 3,
      name: "Completed",
      nameAr: "منجز",
      key: "Completed",
      classColor: "success",
    },
    {
      id: 4,
      name: "Canceled",
      nameAr: "ملغاة",
      key: "Canceled",
      classColor: "danger",
    },
    {
      id: 5,
      name: "Signed",
      nameAr: "موقعة",
      key: "Signed",
      classColor: "info",
    },
  ],
  statusesEnum: {
    getById: function (id) {
      const status = constants.statuses.find((s) => s.id == id);
      return status ? constants.statusesEnum[status.key.toLowerCase()] : {};
    },
    draft: {
      key: "Draft",
      value: 1,
      data: function () {
        return constants.statuses.find((x) => x.id === this.value);
      },
    },
    inprogress: {
      key: "InProgress",
      value: 2,
      data: function () {
        return constants.statuses.find((x) => x.id === this.value);
      },
    },
    completed: {
      key: "Completed",
      value: 3,
      data: function () {
        return constants.statuses.find((x) => x.id === this.value);
      },
    },
    canceled: {
      key: "Canceled",
      value: 4,
      data: function () {
        return constants.statuses.find((x) => x.id === this.value);
      },
    },
    signed: {
      key: "Signed",
      value: 5,
      data: function () {
        return constants.statuses.find((x) => x.id === this.value);
      },
    },
  },
  categoriesEnum: {
    Incoming: 1,
    Outgoing: 2,
    Internal: 3,
    Decree: 4,
    Circular: 5,
    Contract: 10
  },

  purposesEnum: {
    ForAction: 3,
    ForInfo: 4,
    ForReview: 7,
    ForSignature: 8,
    CCed: 10,
    Approved: 11,
    Rejected: 12,
    PrepareResponse: 13,
    Cancel: 14,
    ForEndorsement: 15,
    ForDirection: 16,
    ApprovedSignManual: 17,
    Canceled: 18,
    Revoked: 19,
    ForFollowUp: 20,
    ForCoordination: 21,
    ForDiscussion: 22,
    NeedFeedback: 23,
    EyesOnly: 24,
    ForApproval: 25,
    ToEdit: 26,
  },

  ctsActionResultsEnums: {
    Success: 1,
    Warning: 2,
    Failure: 3
  },

  ctsErrCodesEnums: {
    TransferError: 1
  },

  transferErrorsEnums: {
    PrivacyLevelOfStructureReceiver: 1
  },
  categories_Helper_Enum: {
    getByKey: function (key) {
      for (var tmpKey in this) {
        if (this.hasOwnProperty(tmpKey)) {
          var item = this[tmpKey];
          if (item.key === key) return item;
        }
      }

      return {};
    },
    Incoming: { key: "Incoming", value: 1, text: "res_incoming" },
    Outgoing: { key: "Outgoing", value: 2, text: "res_outgoing" },
    Internal: { key: "Internal", value: 3, text: "res_internal" },
    Decree: { key: "Decree", value: 4, text: "res_MenuItems_Decree" },
    Circular: { key: "Circular", value: 5, text: "res_MenuItems_Circular" },
    Contract: { key: "Contract", value: 10, text: "res_MenuItems_Contract" },
  },
  deliveryType_Enum: {
    email: 1,
    fax: 2,
    relatedStructure: 3,
    logisticsServices: 4,
  },
  signStatusEnum: {
    getByKey: function (key) {
      for (var tmpKey in this) {
        if (this.hasOwnProperty(tmpKey)) {
          var item = this[tmpKey];
          if (item.key === key) return item;
        }
      }

      return {};
    },
    Pending: { key: "Pending", value: 1, text: "res_Label_Pending" },
    InProgress: { key: "In Progress", value: 2, text: "res_Label_InProgress" },
    Signed: { key: "Signed", value: 3, text: "res_Label_Signed" },
  },
  templateSignatureCountLimit: 20,

  actionsEnum: {
    features: {
      Sign: {
        key: "sign",
        value: 1,
      },
      SignAndSend: {
        key: "signandsend",
        value: 2,
      },
      VisualTracking: {
        key: "visualtracking",
        value: 3,
      },
      SecretTransfer: {
        key: "secrettransfer",
        value: 4,
      },
      Reports: {
        key: "reports",
        value: 5,
      },
      CreateDesignatedPerson: {
        key: "createdesignatedperson",
        value: 6,
      },
      DocumentTags: {
        key: "documenttags",
        value: 6,
      },
      DocumentTagsAdd: {
        key: "documenttags-add",
        value: 6,
      },
    },
    toolbarMenu: {
      PublishToMultiDocument: {
        key: "publishtomultidocument",
        value: 1,
      },
      DispatchCorrespondence: {
        key: "dispatchcorrespondence",
        value: 1,
      },
      VisualTracking: {
        key: "visualtracking",
        value: 1,
      },
      Preview: {
        key: "preview",
        value: 1,
      },
      SigningHistory: {
        key: "signinghistory",
        value: 1,
      },
      Forward: {
        key: "forward",
        value: 1,
      },
      Endorse: {
        key: "endorse",
        value: 1,
      },
      Archive: {
        key: "archive",
        value: 1,
      },
      SendBack: {
        key: "sendback",
        value: 1,
      },
      Reject: {
        key: "reject",
        value: 1,
      },
      Recall: {
        key: "recall",
        value: 1,
      },
      DeleteDraft: {
        key: "deletedraft",
        value: 1,
      },
      NotifyEmail: {
        key: "notifyemail",
        value: 1,
      },
      CancelFollowup: {
        key: "cancelfollowup",
        value: 1,
      },
      Sign: {
        key: "sign",
        value: 1,
      },
      SignAndSend: {
        key: "signandsend",
        value: 1,
      },
      Dismiss: {
        key: "dismiss",
        value: 1,
      },
      CreateOutgoing: {
        key: "createoutgoing",
        value: 1,
      },
      CreateReply: {
        key: "createreply",
        value: 1,
      },
      ForceGenerateReferenceNumber: {
        key: "forcegeneratereferencenumber",
        value: 1,
      },
      GenerateDeliveryNote: {
        key: "generatedeliverynote",
        value: 1,
      },
      HideCorrespondence: {
        key: "hidecorrespondence",
        value: 1,
      },
      EmailReminder: {
        key: "emailreminder",
        value: 1,
      },
      ResetDocument: {
        key: "resetdocument",
        value: 1,
      },
      Approve: {
        key: "approve",
        value: 1,
      },
      ReplaceOriginalMail: {
        key: "replaceoriginalmail",
        value: 1,
      },
      SaveForLater: {
        key: "saveforlater",
        value: 1,
      },
      Complete: {
        key: "complete",
        value: 1,
      },
    },
  },

  
  // for adports
  hrmsEmployeeList: [],
  enableUserMultipleSignatures : false,
  userActions: {},

  showDocumentType: sessionStorage.getItem("showDocumentType") === "true",
};

if (localStorage.getItem("lang") == "ar") {
  let toBeTranslatedProperties = [
    "priorities",
    "privacies",
    "importancies",
    "statuses",
    "categories",
    "contactRoles",
    "documentTypes",
  ];
  for (var i = 0; i < toBeTranslatedProperties.length; i++) {
    if (
      constants[toBeTranslatedProperties[i]] == null ||
      constants[toBeTranslatedProperties[i]] == undefined
    )
      continue;

    for (var j = 0; j < constants[toBeTranslatedProperties[i]].length; j++) {
      constants[toBeTranslatedProperties[i]][j].name =
        constants[toBeTranslatedProperties[i]][j].nameAr;
    }
  }
}

export default constants;
